<template>
  <div class="procurement-info">
    <GlobalHeader />
    <main class="main-container">
      <div class="page-header">
        <div class="page-bg"></div>
        <div class="content-wrapper">
          <div class="breadcrumb">您当前的位置：招标信息</div>
          <h1 class="page-title">招标信息</h1>
        </div>
      </div>
      <div class="container">
        <!-- Search Bar -->
        <div class="search-container">
          <a-input-search placeholder="公告名称"
           size="large" 
           v-model="params.Key"
           @search="onSearch" 
           class="custom-search"
           >
            <a-button slot="enterButton" 
            type="primary" class="custom-button">
              <a-icon type="search" />
              搜索
            </a-button>
          </a-input-search>
        </div>

        <div class="main-content">
          <!-- Content Tabs -->
          <div class="content-tabs">
            <span v-for="tab in tabs" :key="tab.id" 
            :class="['tab', tab.id == activeTab ? 'active' : '']"
              @click="handleTabClick(tab.id)">{{ tab.name }}
            </span>
          </div>

          <!-- Procurement List -->
          <div class="procurement-list">
            <div class="procurement-item" v-for="item in procurementItems" :key="item.id"
              @click="handleProcurementClick(item.id)">
              <div class="item-header">
                <div class="bullet"></div>
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ $moment(item.createdDate).format('YYYY-MM-DD HH:mm') }}</div>
              </div>
              <div class="item-details">
                <div class="detail-item">项目编号：{{ item.projectCode }}</div>
                <div class="detail-item">招标方式：{{ item.tenderMethodName }}</div>
                <!-- <div v-if="activeTab == 1 || activeTab == 2" class="detail-item">报名截止日期：{{ item.registrationDeadline }}</div> -->
              </div>
            </div>
            <div class="pagination">
              <span>共{{ total }}条</span>
              <a-pagination 
                show-quick-jumper 
                :current="params.CurrentPage" 
                :total="total" 
                :pageSize="params.ItemsPerPage"
                @change="onChange" 
              />
            </div>
          </div>
        </div>
      </div>
    </main>
    <GlobalFooter />
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue';
import GlobalFooter from '@/components/GlobalFooter.vue';
import { getNoticeList } from '@/api/common';
const tabs = [
  { id: 1, name: '招标公告' },
  { id: 2, name: '更正公告' },
  { id: 3, name: '结果公告' },
  { id: 4, name: '终止公告' }
]
export default {
  name: 'ProcurementInfo',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  data() {
    return {
      tabs,
      activeTab: this.$route.query.type || 1,
      params:{
        Key:'',
        type:1,//类型 项目公告类型 1=招标公告 2=更正公告 3=结果公告 4=终止公告
        CurrentPage:1,
        ItemsPerPage:10
      },
      total: 0,
      loading: false,
      procurementItems: []
    };
  },
  created() {
    if (this.activeTab) {
      this.params.type = this.activeTab;
    }
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      getNoticeList(this.params).then(res => {
        if (res && res.items) {
          this.procurementItems = res.items.map(item => ({
            id: item.id,
            title: item.title,
            createdDate: item.createdDate ? item.createdDate.split('T')[0] : '',
            projectCode: item.projectInfo ? (item.projectInfo.projectCode || '--') : '--',
            tenderMethodName: item.projectInfo ? (item.projectInfo.tenderMethodName || '--') : '--',
            registrationDeadline: (item.projectInfo && item.projectInfo.registrationDeadline) ? item.projectInfo.registrationDeadline.replace('T', ' ').substring(0, 16) : '--'
          }));
          this.total = res.totalItemCount;
        } else {
          this.procurementItems = [];
          this.total = 0;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    onSearch(value) {
      this.params.CurrentPage = 1;
      this.fetchData();
    },
    handleTabClick(id) {
      this.activeTab = id;
      this.params.type = id;
      this.params.CurrentPage = 1;
      this.fetchData();
    },
    onChange(page) {
      this.params.CurrentPage = page;
      this.fetchData();
    },
    handleProcurementClick(id) {
      this.$router.push({ path: '/procurement-detail', query: { id:id } })
    }
  }
};
</script>

<style scoped lang="less">
@import '~@/styles/variables.less';

.procurement-info {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  font-family: 'PingFang SC', sans-serif;
}
.main-container {
  min-height: calc(100vh - 249px);
}
.container {
  width: 1200px;
  margin: auto;
  height: 100%;
}

.page-header {
  width: 100%;
  height: 127px;
  background-color: #5772C3;
  padding-top: 40px;
  box-sizing: border-box;
  margin-bottom: 65px;
  position: relative;

  .page-bg {
    width: 81%;
    height: 120px;
    background: url('@/assets/homeImages/home-header-bg01.png') no-repeat;
    background-size: 100% 100%;

  }

  .content-wrapper {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translate(-50%);
    width: 1200px;
    height: 120px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;

    .breadcrumb {
      font-size: 14px;
      color: #000000;
      line-height: 1.5;
    }

    .page-title {
      font-size: 32px;
      font-weight: bold;
      color: #000000;
      margin: 0;
      line-height: 1.5;
    }
  }
}


.search-container {
  width: 1200px;
  margin: 0 auto;

  .custom-button {
    color: #fff;
  }

  :deep(.ant-input-search) {
    .ant-input {
      height: 60px;
      font-size: 18px;
      padding-left: 32px;
      border-color: #DBDCE7;

      &:hover,
      &:focus {
        border-color: #5772C3;
      }
    }

    .ant-input-search-button {
      height: 60px;
      width: 232px;
      font-size: 18px;
      background-color: #5772C3;
      border-color: #5772C3;

      &:hover {
        background-color: #4a61a8;
        border-color: #4a61a8;
      }
    }
  }
}

.main-content {
  display: flex;
  margin-top: 40px;
  padding-bottom: 40px;
}

.content-tabs {
  width: 190px;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.tab {
  margin-bottom: 48px;
  font-size: 17px;
  color: #000000;
  cursor: pointer;
  text-align: left;
}

.tab.active {
  color: #5772C3;
  font-weight: 400;
}

.procurement-list {
  flex: 1;
  padding: 0 0 0 28px;
  border-left: 1px solid #EAEBF5;
  margin-left: 28px;

  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    >span {
      margin-right: 20px;
    }
  }
}

.procurement-item {
  padding: 12px 0;
  border-bottom: 1px solid #EAEBF5;
  cursor: pointer;
}

.procurement-item:last-child {
  border-bottom: none;
}

.item-header {
  display: flex;
  align-items: center;
}

.bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #5772C3;
  margin-right: 8px;
  flex-shrink: 0;
}

.title {
  flex: 1;
  font-size: 16px;
  color: #000000;
  line-height: 1.5;
  font-weight: 400;
}

.date {
  font-size: 16px;
  color: #000000;
  text-align: right;
  line-height: 1.5;
  font-weight: 400;
  margin-left: 20px;
  flex-shrink: 0;
}

.item-details {
  display: flex;
  align-items: center;
  margin-top: 12px;
  gap: 48px;
}

.detail-item {
  font-size: 14px;
  color: #606472;
  line-height: 1.5;
  font-weight: 400;
}
</style>